// @ts-nocheck
const getCurrentLanguageKey = (params?: { defaultKey?: 'es' | 'pt' | 'en' }) => {
  const defaultKey: 'es' | 'pt' | 'en' = (params && params.defaultKey) || 'es';

  if (
    typeof window !== 'undefined' &&
    window.__INITIAL_STATE__ &&
    window.__INITIAL_STATE__.LANGUAGE_KEY
  ) {
    return window.__INITIAL_STATE__.LANGUAGE_KEY as 'es' | 'pt' | 'en';
  }
  return defaultKey;
};

export default getCurrentLanguageKey;
